import { useTheme } from '@mui/material'
import Menu, { MenuProps } from '@mui/material/Menu'

export function ContextMenu(props: MenuProps) {
  const theme = useTheme()
  return (
    <Menu
      sx={{
        '& .MuiList-root': { padding: theme.spacing.S, gap: theme.spacing.M },
        '& .MuiMenu-paper': { borderRadius: theme.radius.M },
      }}
      {...props}
    />
  )
}
